import React from 'react';
import { NavLink, Link } from 'react-router-dom';


const Footer = () => {
    const SocialMediaLinks = JSON.parse(localStorage.getItem("outletdataLocal")) || {};
  return (
    <>
              <nav className="navbar navbar-light shadow-sm bg-body rounded">
  <div className="container-fluid p-0">
    <div className="row w-100 d-flex justify-content-around align-items-center">
      
    <div className="col-2 d-flex flex-column align-items-center">
  <NavLink className="nav-link mb-0 d-flex flex-column align-items-center" to="/">
    <img width="22" height="22" src="https://img.icons8.com/?size=100&id=idja0q6oFAQN&format=png&color=000000" alt=""/>
    <span style={{ fontSize: "10px", color: "black", marginTop: "-1px" }}>Home</span>
  </NavLink>
</div>
      
      <div className="col-2 d-flex flex-column align-items-center">
      <NavLink className="nav-link mb-0 d-flex flex-column align-items-center" to={SocialMediaLinks[0].gglReviewUrl || "#"}>
      <img width="22" height="22" src="https://img.icons8.com/fluency/48/google-logo.png" alt=""/>
        <span style={{ fontSize: "10px", color: "black", marginTop: "-1px" }}>Review</span>  
      </NavLink>
      </div>
      
      <div className="col-2 d-flex flex-column align-items-center">
      <NavLink className="nav-link mb-0 d-flex flex-column align-items-center" to={SocialMediaLinks[0].faceBookUrl || "#"}>
      <img width="22" height="22" src="https://img.icons8.com/?size=100&id=118497&format=png&color=000000" alt=""/>
        <span style={{ fontSize: "10px", color: "black", marginTop: "-1px"  }}>Facebook</span>
        </NavLink>
      </div>
      
      <div className="col-2 d-flex flex-column align-items-center">
      <NavLink className="nav-link mb-0 d-flex flex-column align-items-center" to={SocialMediaLinks[0].instagramUrl || "#"}>
      <img width="22" height="22" src="https://img.icons8.com/?size=100&id=Xy10Jcu1L2Su&format=png&color=000000" alt=""/>
        <span style={{ fontSize: "10px", color: "black", marginTop: "-1px"  }}>Instagram</span>
        </NavLink>
      </div>


      <div className="col-2 d-flex flex-column align-items-center">
      <NavLink className="nav-link mb-0 d-flex flex-column align-items-center" to="/Login">
      <img width="22" height="22" src="https://img.icons8.com/?size=100&id=48179&format=png&color=000000" alt=""
      onclick = {localStorage.setItem("backPaath", "/")}
      />
        <span style={{ fontSize: "10px", color: "black", marginTop: "-1px"  }}>LogIn</span>
        </NavLink>
      </div>


      {/* <div className="col-2 d-flex flex-column align-items-center">
      <NavLink className="nav-link mb-0 d-flex flex-column align-items-center" to="/MyOrders">
      <img width="22" height="22" src="https://img.icons8.com/?size=100&id=83967&format=png&color=000000" alt=""/>
      <span style={{ fontSize: "10px", color: "black", marginTop: "-1px"  }}>MyOrders</span>
      </NavLink>
      </div> */}
    </div>
  </div>
</nav>

    </>
  );
}

export default Footer;
